import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, inView = false, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block will-change-transform pb-[0.14em] -mb-[0.14em] ${className}`}
      initial={{ y: "118%" }}
      {...(inView
        ? { whileInView: { y: "0%" }, viewport: { once: true, margin: "-60px" } }
        : { animate: { y: "0%" } })}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const ClipReveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ clipPath: "inset(100% 0% 0% 0%)" }}
    {...(delay === 0
      ? { whileInView: { clipPath: "inset(0% 0% 0% 0%)" }, viewport: { once: true, margin: "-80px" } }
      : { animate: { clipPath: "inset(0% 0% 0% 0%)" } })}
    transition={{ duration: 1.2, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);
